module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_e/aoj_e-4-b6d7b20dafcdc16f8dc8ba43f52286a9.jpg";